<template>
  <span v-if="label" class="tag is-rounded ml-2" :class="isCvz ? 'is-warning' : 'is-light'" :title="title">
    {{ label }}
  </span>
</template>

<script setup>
// Individueel or CVZ (centrale voorzieningen, a collective connection in hoogbouw) next to the
// address: household_type of the household in the clients service, via the client details the
// Bewoner tab also loads.
import { computed } from 'vue'
import { useQuery } from '@tanstack/vue-query'
import request from '@/requests'
import { STATUS_OK } from '@/constants'

const props = defineProps({
  address: { type: String, default: '' },
})

const { data: householdType } = useQuery({
  queryKey: computed(() => ['householdType', props.address]),
  queryFn: async () => {
    const response = await request.clients.getClientDetailsForEdit(props.address)
    return response.status === STATUS_OK ? response.data?.household?.household_type ?? null : null
  },
  enabled: computed(() => !!props.address),
  refetchOnWindowFocus: false,
  staleTime: 5 * 60 * 1000,
})

const isCvz = computed(() => householdType.value === 'cvz')
const label = computed(() => {
  if (!householdType.value) return ''
  return isCvz.value ? 'CVZ' : 'Individueel'
})
const title = computed(() =>
  isCvz.value ? 'Centrale voorzieningen: collectieve aansluiting' : 'Individuele woning'
)
</script>
